export abstract class Environment {
  api: string;
  devMode: boolean;
  ganalottodoUrl: string;
}



// WEBPACK FOOTER //
// /codebuild/output/src14910448/src/src/app/core/environment-core.ts